import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { OngoingMissingInventoryEmailEditTemplate } from 'themes/application/ongoing-missing-inventory/pages';
import { OngoingMissingInventoryEmailEditViewStore } from 'application/ongoing-missing-inventory/stores';

@setCurrentView((rootStore) => new OngoingMissingInventoryEmailEditViewStore(rootStore), 'ongoingMissingInventoryEmailEditViewStore')
@observer
class OngoingMissingInventoryEmailEdit extends React.Component {
    render() {
        return <OngoingMissingInventoryEmailEditTemplate {...this.props} />
    }
}

export default OngoingMissingInventoryEmailEdit;
